import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface PackageTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  productsCount?: number;
}

const PackageTab: React.FC<PackageTabProps> = ({ tab, onChange, productsCount }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      <Tab value="main" label="Dados do pacote" />
      <Tab value="products" label={<CountLabel label="Produtos" count={productsCount} />} />
    </RecordTabs>
  );
};

export default PackageTab;
